
.SingleDayBackgroundEvent {
    position: absolute;
    width: 8px;
    left: -4px;
}

.SingleDayBackgroundEvent_placeholder {
    cursor: pointer;
    display: block;
    background: var(--soniq-t--global--background--color--status--warning--strong);
    border-radius: 4px;
    width: 100%;
    height: 100%;
    border: solid 1px #fff;
    padding: 0;
    transition: background-color .1s ease-in;
}

.SingleDayBackgroundEvent_popover {
    composes: Scheduler-variables from '../Scheduler/Scheduler.module.css';
    background: var(--soniq-t--global--background--color--contrast--default);
    color: var(--soniq-t--global--text--color--regular--contrast);
    border: solid 1px rgba(100, 100, 100, 0.2);
    border-left: solid 4px var(--soniq-t--global--border--color--status--warning--strong);
    cursor: pointer;
    padding: var(--Scheduler-spacing-sm);
    width: 10rem;
}
